// extracted by mini-css-extract-plugin
module.exports = {"container":"Xi-z","heading":"Yi-z","links":"Zi-z","linkBtn":"_i-z","disabled":"aj-z","linkUppercaseBold":"bj-z","copy":"cj-z","subCopy":"dj-z"};